import { BILLING_PAYMENT_OPTION_KR, ONE_TIME_PAYMENT_OPTION_KR } from 'src/constants/checkout';
import { postOrder } from './checkout';
import { createScripts, isKorean } from './util';
const scripts = ['https://code.jquery.com/jquery-1.12.4.min.js', 'https://cdn.iamport.kr/js/iamport.payment-1.1.5.js'];

export default class IamPort {
  private _imp: any;
  private _order: CheckoutOrderData = {} as CheckoutOrderData;
  private _product: CheckoutProductData = {} as CheckoutProductData;
  private _paymentOptions: IamPortPaymentOption[] = [];
  private _promotionData: CheckoutPromotionCodeData = {} as CheckoutPromotionCodeData;
  constructor() {
    console.log('creat iamport');
  }

  async init(product: CheckoutProductData): Promise<void> {
    this.setProduct(product);
    await createScripts(scripts);
    this._imp = (window as any).IMP;
    this._imp.init(process.env.REACT_APP_IMP_CODE);
  }

  destroy(): void {
    if (!this._imp) {
      return;
    }
    scripts.map((src) => {
      document.querySelector(`script[src="${src}"]`)?.remove();
    });
    this._imp = null;
    this._order = {} as CheckoutOrderData;
    this._product = {} as CheckoutProductData;
    this._paymentOptions = [];
    this._promotionData = {} as CheckoutPromotionCodeData;
  }

  async buyItem(paymentOption: IamPortPaymentOption): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        await this.getOrder();
      } catch (e) {
        reject(e);
      }

      try {
        this._imp.request_pay(
          {
            // popup: true,
            // buyer_email: $('#userEmail').val(),
            // pg,
            // pay_method: payMethod,
            // name: data.name,
            // amount: data.amount,
            // notice_url: noticeUrl,
            pg: paymentOption.pg,
            pay_method: paymentOption.payMethod,
            notice_url: paymentOption.noticeUrl,
            name: isKorean() ? this._product.koName : this._product.enName,
            amount: this._order.paymentAmount,
            merchant_uid: (this._product.subscription ? '[Billingkey]' : '') + 'KYoungPay_User_' + new Date().getTime(),
            m_redirect_url:
              (process.env.REACT_APP_IAMPORT_MOBILE_REDIRECT_URL || '') +
              `?orderId=${this._order.id}&productId=${this._product.id}&payMethod=${paymentOption.payMethod}`,
            ...(this._product.subscription
              ? {
                  customer_uid: this._order.id,
                }
              : {}),
            custom_data: {
              orderId: this._order.id,
              payMethod: paymentOption.payMethod,
            },
          } as IamPortRequestPayParams,
          (res: IamPortRequestPayResponse) => {
            const result = {
              orderId: this._order.id,
              productId: this._product.id,
            };
            res.success
              ? resolve({
                  ...result,
                  imp_success: 'true',
                })
              : reject({
                  ...result,
                  payMethod: paymentOption.payMethod,
                  imp_success: 'false',
                });
          },
        );
      } catch (e) {
        reject(e);
      }
    });
  }

  async getOrder(): Promise<void> {
    try {
      const order = await postOrder({
        productId: this._product.id,
        ...(this._promotionData && this._promotionData.id
          ? {
              promotionId: this._promotionData.id,
            }
          : {}),
      });
      this.setOrder(order.order);
    } catch (e) {
      throw e;
    }
  }

  setOrder(order: CheckoutOrderData): void {
    this._order = order;
  }

  setProduct(product: CheckoutProductData): void {
    this._product = product;
    this._paymentOptions = product.subscription ? BILLING_PAYMENT_OPTION_KR : ONE_TIME_PAYMENT_OPTION_KR;
  }

  getPaymentOptions(): IamPortPaymentOption[] {
    return this._paymentOptions;
  }

  setPromotionCode(promotionData: CheckoutPromotionCodeData): void {
    this._promotionData = promotionData;
  }
}
